const smartixRow1 = {
  single: [{
    "body": "{{__event__.__date__}}",
    "dateStyle": "PKDateStyleShort",
    "header": "Date",
    "id": "__SMARTIX_DATE__"
  },
  {
    "body": "{{__event__.__date__}}",
    "header": "Time",
    "id": "__SMARTIX_TIME__",
    "timeStyle": "PKDateStyleShort"
  }],
  multiple: [{
    "body": "{{__event__.__date__}}",
    "dateStyle": "PKDateStyleShort",
    "header": "Date",
    "id": "__SMARTIX_DATE__"
  },
  {
    "body": "{{__event__.__date__}}",
    "header": "Time",
    "id": "__SMARTIX_TIME__",
    "timeStyle": "PKDateStyleShort"
  },
  {
    "body": "{{__event__.__ticket_type__}}",
    "header": "ticket type",
    "id": "__SMARTIX_TICKET_TYPE__"
  }
  ]
}

const smartixRow2 = {
  seat: [
    {
      "body": "{{__seating__.__*_seat__}}",
      "header": "seat",
      "id": "__SMARTIX_SEAT__"
    }
  ],
  row: [
    {
      "body": "{{__seating__.__*_+row__}}",
      "header": "row",
      "id": "__SMARTIX_ROW__"
    },
    {
      "body": "{{__seating__.__*_seat__}}",
      "header": "seat",
      "id": "__SMARTIX_SEAT__"
    }
  ],
  section: [
    {
      "body": "{{__seating__.__*_section__}}",
      "header": "section",
      "id": "__SMARTIX_SECTION__"
    },

    {
      "body": "{{__seating__.__*_row__}}",
      "header": "row",
      "id": "__SMARTIX_ROW__"
    },
    {
      "body": "{{__seating__.__*_seat__}}",
      "header": "seat",
      "id": "__SMARTIX_SEAT__"
    }
  ],
  gate: [
    {
      "body": "{{__seating__.__*_gate__}}",
      "header": "gate",
      "id": "__SMARTIX_GATE__"
    },
    {
      "body": "{{__seating__.__*_section__}}",
      "header": "section",
      "id": "__SMARTIX_SECTION__"
    },
    {
      "body": "{{__seating__.__*_row__}}/{{__seating__.__*_seat__}}",
      "header": "row/seat",
      "id": "__SMARTIX_ROW_AND_SEAT__"
    }
  ]
}

const standardRow1 = {
  single: [{
    "body": "{{event.date}}",
    "dateStyle": "PKDateStyleShort",
    "header": "Date",
    "id": "DATE"
  },
  {
    "body": "{{event.date}}",
    "header": "Time",
    "id": "TIME",
    "timeStyle": "PKDateStyleShort"
  }],
  multiple: [{
    "body": "{{event.date}}",
    "dateStyle": "PKDateStyleShort",
    "header": "Date",
    "id": "DATE"
  },
  {
    "body": "{{event.date}}",
    "header": "Time",
    "id": "TIME",
    "timeStyle": "PKDateStyleShort"
  },
  {
    "body": "{{ticket_type}}",
    "header": "ticket type",
    "id": "TICKET_TYPE"
  }
  ]
}

const standardRow2 = {
  seat: [
    {
      "body": "{{seating.seat}}",
      "header": "seat",
      "id": "SEAT"
    }
  ],
  row: [
    {
      "body": "{{seating.row}}",
      "header": "row",
      "id": "ROW"
    },
    {
      "body": "{{seating.seat}}",
      "header": "seat",
      "id": "SEAT"
    }
  ],
  section: [
    {
      "body": "{{seating.section}}",
      "header": "section",
      "id": "SECTION"
    },

    {
      "body": "{{seating.row}}",
      "header": "row",
      "id": "ROW"
    },
    {
      "body": "{{seating.seat}}",
      "header": "seat",
      "id": "SEAT"
    }
  ],
  gate: [
    {
      "body": "{{seating.gate}}",
      "header": "gate",
      "id": "GATE"
    },
    {
      "body": "{{seating.section}}",
      "header": "section",
      "id": "SECTION"
    },
    {
      "body": "{{seating.row}}/{{seating.seat}}",
      "header": "row/seat",
      "id": "ROW_AND_SEAT"
    }
  ]
}

const standard = {
  row1 : standardRow1,
  row2 : standardRow2
}

const smartix = {
  row1 : smartixRow1,
  row2 : smartixRow2
}

export default {
  standard,
  smartix
}